import axios, { AxiosError } from 'axios';

// Same-origin in production behind Caddy. Override via VITE_API_BASE in dev.
const baseURL = (import.meta.env.VITE_API_BASE as string | undefined) || '/api';

export const TOKEN_KEY = 'sharejet.adminToken';

export const api = axios.create({ baseURL });

// SHAR-1093/1094/1099 — the auth store registers how to drop the session.
// Clearing only localStorage left the in-memory token in place, so an expired
// session stayed on the page with every request failing instead of bouncing
// to login. (Registered from the store to avoid a client <-> store import
// cycle.)
let onUnauthorized: (() => void) | null = null;
export function setOnUnauthorized(fn: () => void) {
  onUnauthorized = fn;
}

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) {
    cfg.headers = cfg.headers ?? {};
    (cfg.headers as any).Authorization = `Bearer ${t}`;
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError) => {
    // SHAR-1099 — only a 401 for the CURRENT session ends it. A request that
    // was sent with an older (expired) token, or with none, and answers after
    // the admin has logged in again must not wipe the new token.
    const sentWith = String((err.config?.headers as any)?.Authorization ?? '');
    const current = localStorage.getItem(TOKEN_KEY);
    const stale = !!current && sentWith !== `Bearer ${current}`;
    if (err.response?.status === 401 && !stale) {
      localStorage.removeItem(TOKEN_KEY);
      // Don't redirect from here — clearing the store's token makes the router
      // auth guard render <Navigate to="/login" state={{ from: location }} />,
      // so the admin lands back on the same page after logging in again.
      onUnauthorized?.();
    }
    return Promise.reject(err);
  },
);
